import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Delete } from '@material-ui/icons';
import moment from 'moment';

import { Tabela } from '~/components';
import { t } from '~/helpers';
import {
  recordFiltering,
  deleteOperacaoAfericao,
  operacaoAfericaoInRequest,
  storeOperacaoAfericao,
  findOperacaoAfericao,
} from '~/store/modules/operacaoafericao/actions';

import OperacaoAbastecimentoForm from './form';

function OperacaoAfericao() {
  const deleteRef = useRef(null);
  const buttons = [];

  const operacaoafericao = useSelector((state) => state.operacaoafericao);

  const { internounidatausuario } = useSelector((state) => state.user.configs);

  const initialDate = moment()
    .set({ hour: 0, minute: 0, second: 0 })
    .format('YYYY-MM-DDTHH:mm');

  const finalDate = moment()
    .set({ hour: 23, minute: 59, second: 59 })
    .format('YYYY-MM-DDTHH:mm');

  const header = [
    {
      id: 'datahorainicialafericao',
      label: t('s.operacao.abastecimento.datahorainicialmovimentacao'),
      format: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
      filter: {
        type: 'initialdatetime',
        defaultValue: initialDate,
      },
    },
    {
      id: 'datahorafinalafericao',
      label: t('s.operacao.abastecimento.datahorafinalmovimentacao'),
      format: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
      filter: {
        type: 'finaldatetime',
        defaultValue: finalDate,
      },
    },
    {
      id: 'nomeposto',
      label: t('s.operacao.abastecimento.nomeposto'),
      filter: {
        type: 'text',
      },
    },
    {
      id: 'idbico',
      label: t('s.operacao.abastecimento.idbico'),
      filter: {
        type: 'number',
      },
      align: 'left',
    },
    {
      id: 'volumeregistradoafericao',
      label: t('s.geral.camposistema.volumeregistradoafericao'),
      filter: {
        type: 'number',
      },
      align: 'left',
    },
    {
      id: 'volumeaferidoafericao',
      label: t('s.geral.camposistema.volumeaferidoafericao'),
      filter: {
        type: 'number',
      },
      align: 'left',
    },
    {
      id: 'observacaoafericao',
      label: t('s.geral.camposistema.observacaoafericao'),
      filter: {
        type: 'text',
      },
      align: 'left',
    },
  ];

  if (internounidatausuario === 'S') {
    buttons.push({
      title: t('s.geral.botaoexcluir'),
      action: (value) => deleteRef.current.handleOpen(value),
      icon: <Delete />,
    });
  }

  return (
    <Tabela
      read={operacaoAfericaoInRequest}
      // remove={deleteOperacaoAfericao}
      state={operacaoafericao}
      remove={deleteOperacaoAfericao}
      header={header}
      headerMobile="nomeposto"
      unique={['idafericao']}
      form={OperacaoAbastecimentoForm}
      findItem={findOperacaoAfericao}
      recordFilter={recordFiltering}
    />
  );
}

export default OperacaoAfericao;
